import { Box, Card, Typography } from "@mui/material";
import React, { ReactElement } from "react";
import { MenuModel } from "../../../../../store/api/upsellApi";
import { grey } from "@mui/material/colors";

export default function Menu<M extends MenuModel>({
  menu,
  leftAction,
  rightAction,
}: {
  menu: M;
  leftAction?: ReactElement;
  rightAction?: ReactElement;
}) {
  return (
    <Card
      sx={{
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        gridTemplateAreas: `
        "left-action menu right-action"
        `,
        borderColor: "divider",
      }}
    >
      {leftAction ? (
        <Box
          sx={{
            gridArea: "left-action",
            mx: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {leftAction}
        </Box>
      ) : (
        <Box sx={{ gridArea: "left-action", ml: 1 }} />
      )}
      <Box sx={{ gridArea: "menu", py: 0.5 }}>
        <Typography>{menu.naam ?? "No name"}</Typography>
        <Typography sx={{ color: "text.secondary", fontSize: "0.9em" }}>#{menu.id}</Typography>
      </Box>
      {rightAction ? (
        <Box
          sx={{
            gridArea: "right-action",
            background: grey["50"],
            height: "100%",
            display: "flex",
          }}
        >
          {rightAction}
        </Box>
      ) : (
        <Box sx={{ gridArea: "right-action", mr: 1 }} />
      )}
    </Card>
  );
}
